<script>
  export default {
    props: {
      buttonList: {
        type: Array,
        default: () => {
          return [
            {
              text: 'button',
              class: 'isStylePrimary isCircle isSmaller isOutline2 flex-shrink-0',
              isLoading: false,
              isDisabled: false,
              onClick: () => {
              },
            }
          ]
        }
      },
      isShow: {
        type: Boolean,
        default: false
      }
    },
  }
</script>
<template>
  <div :class="[$style.baseBottomBar, { [$style.isShow]: isShow }]">
    <div :class="$style.baseBottomBarList">
      <div
        v-for="(buttonItem, index) in buttonList"
        :key="`buttonList-${index}`"
        :class="`baseBottomBarList__item ${buttonItem.class}`"
      >
        <BaseButton
          class="buttonList__button"
          :class="buttonItem.buttonClass"
          :loading="buttonItem.isLoading"
          :disabled="buttonItem.isDisabled"
          @click="buttonItem.onClick()"
        >
          <span v-html="buttonItem.text"></span>
        </BaseButton>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
  .baseBottomBar {
    position: fixed;
    bottom: -94px;
    left: 0;
    z-index: 1999;
    width: 100vw;
    padding: 20px 24px 24px;
    background-color: #FFF;
    box-shadow: 0 -1px 4px #1C2C5414;
    transition: bottom .3s;

    &.isShow {
      bottom: 0
    }

    :global {
      .baseBottomBar {
        @include unstyled;
      }
    }
  }

  .baseBottomBarList {
    // display: flex;
    // align-items: center;
    // margin: 0 -0.5rem;

    :global {
      .baseBottomBarList {
        &__item {
          padding: 0 0.5rem;
          &:not(:last-child) {
            margin-bottom: 1rem
          }
        }

        &__button {
          @include unstyled;
        }
      }
    }
  }
</style>
